export default __webpack_public_path__ + "static/media/harsh.873e3f02.png";